import { render, staticRenderFns } from "./ReservationTitleLogo.vue?vue&type=template&id=67479cf8&scoped=true"
import script from "./ReservationTitleLogo.vue?vue&type=script&lang=js"
export * from "./ReservationTitleLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67479cf8",
  null
  
)

export default component.exports